import { render, staticRenderFns } from "./RentalGinIndex.vue?vue&type=template&id=20792e8a"
import script from "./RentalGinIndex.vue?vue&type=script&lang=js"
export * from "./RentalGinIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports